import { render, staticRenderFns } from "./GroupCategoriesSelectorModal.vue?vue&type=template&id=9e53adfc&scoped=true"
import script from "./GroupCategoriesSelectorModal.vue?vue&type=script&lang=js"
export * from "./GroupCategoriesSelectorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e53adfc",
  null
  
)

export default component.exports